import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CellEditArgs, DataStateChangeEventArgs, EditSettingsModel, FilterSettingsModel, GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { columnWidth } from '../employee/employee.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { GetEventListBo, SaveEventBo } from './events.modal';
import { EventsServices } from './events.service';
import { ConsultationServices } from '../consultation-services/consultation-services.service';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { Router } from '@angular/router';

import { CellSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { log } from 'node:console';
import { EventsShareService } from './eventsShare.service';
import { inputs } from '@syncfusion/ej2-angular-grids/src/grid/grid.component';
@Component({
  selector: "app-events",
  templateUrl: "./events.component.html",
  styleUrls: ["./events.component.scss"],
})
export class EventsComponent implements OnInit {
  EBO: GetEventListBo = new GetEventListBo();
  startmin: string = "";
  EvaluesList: any = [];
  public selectionOptions: SelectionSettingsModel;
  EventsDataList: any = [];
  EAList: any = [];
  FilterStartDate: any = "";
  FilterEndDate: any = "";
  StartDate: any = "";
  EndDate: any = "";
  ClientList: any = "";
  ConsultantList: any = "";
  EventsDeleteId: any = "";
  @ViewChild("gridEvents") public gridEvents: GridComponent;
  saveBo: SaveEventBo = new SaveEventBo();
  public GridDataEvent: Observable<DataStateChangeEventArgs>;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  arraycol: any = [];

  isDateCheck:boolean=false;
    public editSettings: EditSettingsModel;
  ColumnArray: columnWidth[];
  filterOptions: FilterSettingsModel;
  datetimeformat: object;
  dateformat: object;
  isOngoing: boolean = false;
  isQAL: boolean = false;
  isSSL: boolean = false;
  EventList: any = [];
  ContactList: any = [];
  UserDropDownList: any = [];
  StatusList: any;

  selectedLanguages: any = [];
  languageList: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true,
  };
  issdp: boolean = false;
  isEditClient: boolean = false;
  @Input() inputfromCalendar:boolean;
  @Output() emitfromEvents =new EventEmitter<boolean>();
  clientConfirmation: boolean;
  getConfirmation: boolean;
  msg : string ;
  constructor(
    public datepipe: DatePipe,
    public dateservice: DateService,
    public global: GlobalComponent,
    public EventService: EventsServices,
    private toastrService: ToastrService,
    public CSService: ConsultationServices,
    public ClientService: ClientHttpService,
    public router: Router,
    private eventsShare: EventsShareService
  ) {
    this.GridDataEvent = this.EventService;
  }

  cfssModel = ["AGENCY", "BUDGET"];
  ngOnInit(): void {
    if (
      this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000"
    ) {
      return;
    }
    this.startmin = this.global.getDateTimeString(
      new Date(new Date().setFullYear(new Date().getFullYear() + 100))
    );
    this.filterOptions = { type: "Menu" };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.datetimeformat = {
      type: "datetime",
      format: "MM/dd/yyyy h:mm:ss a",
    };

    this.editSettings = {
      allowEditing: false,
      mode: "Normal",
      allowEditOnDblClick: true,
    };
    this.selectionOptions = {
      // checkboxOnly: true
    };
    this.dateformat = {
      type: "date",
      format: "MM/dd/yyyy",
    };
    if (this.global.isSDPtoEvent) {
      this.eventsShare.currentFilterData.subscribe((data) => {
        this.EBO = data;
        this.saveBo.clientId = data.clientId;
        if (data) {
          // Apply filtering logic here if needed
          console.log("Received filter data:", data);
          console.log("Received filter data:", data.clientId);
        }
      });
    }
    if (this.EBO.isedit == true) {
      this.FilterStartDate = this.EBO.startDate;
      this.FilterEndDate = this.EBO.endDate;
    } else {
      this.FilterStartDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.FilterEndDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
    }
  
      this.GetLovDropDown();
      this.GetAllClientDropDown();
      this.GetUserDropDownList();
      this.getEventsListFilter();
      this.GetStatusLovDropDown();
      this.GetServiceType();
      this.GetContactType();
      this.getLanguageList();
    if(this.inputfromCalendar){
      this.saveBo=new SaveEventBo();
      this.addclientid();
      document.getElementById('openEventsModal').click();
    }
    else{
      this.inputfromCalendar=false
      return
    }
  }

  public dataStateChange(state): void {
    let type: String = state.action.requestType.toString();
    this.EBO.currentpageno = this.gridEvents.pagerModule.pagerObj.currentPage;
    this.EBO.pageitem = this.gridEvents.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.EBO.orderColumn = state.sorted[0].name;
        this.EBO.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
      else{
        this.EBO.orderType = 'ASC'
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      this.EBO.currentpageno = 1;
      this.EBO.pageitem = 10;
      if (this.EBO.type == "date") {
        this.EBO.value = new Date(
          new Date(state.action.currentFilterObject.value).toDateString() +
            " " +
            "00:00:00" +
            " " +
            "GMT"
        )
          .toISOString()
          .replace("Z", "");
      } else {
        this.EBO.value = state.action.currentFilterObject.value;
      }
      this.EBO.field = state.action.currentFilterObject.field
      this.EBO.operator = state.action.currentFilterObject.operator;
    }
    if (
      state.action.requestType == "filtering" &&
      state.action.action == "clearFilter"
    ) {
      this.EBO.currentpageno = 1;
      this.EBO.pageitem = 10;
      this.EBO.operator = "contains";
      this.EBO.type = "string";
      this.EBO.value = "";
      this.EBO.field = "clientName";
      this.EBO.orderColumn = "clientName";
      this.EBO.orderType = "ASC";
    }
    if (state.action.requestType != "refresh") {
      this.getEventsListFilter();
    }
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridEvents.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (
            this.arraycol[0].EVV_Timesheet.ShowColumns?.length != count1 ||
            this.arraycol[0].EVV_Timesheet.HideColumns?.length != count
          ) {
            this.arraycol[0].EVV_Timesheet.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }
      }
    }
    if (args.requestType == "filterafteropen") {
      this.EBO.type = args.columnType;
    }
  }
  GetAllClientDropDown() {
    let url = "api/Event/GetEventClientDropDown?";
    this.EventService.GetAllClientDropDown(url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ClientList = data;
        },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, "Error"), 8000;
          }
        }
      );
  }
  GetConsultantDropDown() {}
  GetUserDropDownList() {
    this.EventService.GetUserDropDown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.UserDropDownList = data;
        },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, "Error"), 8000;
          }
        }
      );
  }
  EditEvents(event, data) {
    this.isEditClient = true;
    event.stopPropagation(); // Prevent the event from triggering rowSelected
    document.getElementById("openEventsModal").click();
    this.saveBo = data;
    this.getConfirmation = data.getConfirmation;
    this.saveBo.getConfirmation = false;
    if (
      this.saveBo.serviceDeliveryPlanId == "" ||
      this.saveBo.serviceDeliveryPlanId == null ||
      this.saveBo.serviceDeliveryPlanId == undefined
    ) {
      this.issdp = true;
    } else this.issdp = false;
    this.StartDate =
      data?.startTime != null && data?.startTime != undefined
        ? this.datepipe.transform(data?.startTime, "yyyy-MM-dd HH:mm:ss")
        : "";
    this.EndDate =
      data?.endTime != null && data?.endTime != undefined
        ? this.datepipe.transform(data?.endTime, "yyyy-MM-dd HH:mm:ss")
        : "";
    //  this.EventList=data?.eventAlterList
    this.EventList.forEach((element) => {
      var ele = data?.eventAlterList.filter(
        (a) => a.eventAlertId == element.eventAlertId
      )[0];
      if (ele != null) {
        element.isCheck = ele?.isCheck;
      }
    });
    this.selectedLanguages = data?.languageListIds;
    this.Getclientmodelandlanguage(false);
  }

  getEventsListFilter() {
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.EBO.startDate =
      SDate != null && SDate != undefined && SDate != ""
        ? this.global.getDateTimeString(SDate)
        : null;
    this.EBO.endDate =
      EDate != null && EDate != undefined && EDate != ""
        ? this.global.getDateTimeString(EDate)
        : null;
    this.EventService.outputValues(this.EBO);
    let count = 0;
    this.GridDataEvent.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.EventsDataList = data.result;

        if (this.global.globalAgencyId != 0) {
          if (data != null && data.result?.length > 15) {
            this.gridEvents.height = "500";
          } else {
            this.gridEvents.height = "auto";
          }
        }
        count = count + 1;
        if (data != null && data != undefined && count == 1) {
          //this.getColumnwidth()
        }
      },
      (err :any)=>{
        this.toastrService.error(err);
      }
    );
  }
  Refresh() {
    this.EBO = new GetEventListBo();
    this.getEventsListFilter();
    this.clearEvents();
  }
  clearEvents() {
   
    if(this.inputfromCalendar){
      this.emitfromEvents.emit(false)
    }
    else{
    this.saveBo = new SaveEventBo();
    this.selectedLanguages=[];
    this.missingDocuments=[];
    this.StartDate = ""; this.EndDate = "";
    this.startmin = this.global.getDateTimeString(new Date(new Date().setFullYear(new Date().getFullYear() + 100)));
    this.EventList=JSON.parse(JSON.stringify(this.EvaluesList) );
    }
    
  }
  show() {
    this.gridEvents.columnChooserModule.openColumnChooser();
  }
  getDeleteId(event, data) {
    event.stopPropagation(); // Prevent the event from triggering rowSelected
    this.EventsDeleteId = data.id;
    document.getElementById("openEventsDelete").click();
  }
  DeleteEvents() {
    let params = new URLSearchParams();
    params.append("EventId", this.EventsDeleteId);
    this.EventService.DeleteEvent(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success("Events Deleted Successfully");
          document.getElementById("openEventsDelete").click();
          this.getEventsListFilter();
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        },
        (err: any) => {
          this.toastrService.error(err, " Error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 2000);
        }
      );
  }
  checkTime() {
    if (this.StartDate && this.EndDate) {
      const start = new Date(this.StartDate);
      const end = new Date(this.EndDate);
      if (start?.toDateString() !== end?.toDateString()) {
        this.toastrService.error("Start and End date must be on the same day.");
        return;
      }
    }
    if (
      new Date(this.StartDate).getTime() > new Date(this.EndDate).getTime()
    ) {
      this.toastrService.error("end time should greater than start time");
      setTimeout(() => {
        this.toastrService.clear();
      }, 2000);
      return;
    } else {
      this.OutBoundCall();
    }
  }
  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == "StartDate") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterStartDate = val1;
        }
      }
      if (name == "EndDate") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterEndDate = val1;
        }
      }
    }

    if (type == "datechanged") {
      if (name == "StartDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterStartDate = val1;
        }
      }
      if (name == "EndDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterEndDate = val1;
        }
      }
    }
  }
  SaveEvents() {
    let saveEventsBo: SaveEventBo = JSON.parse(JSON.stringify(this.saveBo));
    saveEventsBo.clientId = this.saveBo.clientId;
    saveEventsBo.startTime =
      this.saveBo.id != null &&
      this.saveBo.id != undefined &&
      this.saveBo.id != "00000000-0000-0000-0000-000000000000"
        ? this.global.getDateTimeString(this.StartDate)
        : this.StartDate;
    saveEventsBo.endTime =
      this.saveBo.id != null &&
      this.saveBo.id != undefined &&
      this.saveBo.id != "00000000-0000-0000-0000-000000000000"
        ? this.global.getDateTimeString(this.EndDate)
        : this.EndDate;
    saveEventsBo.id = this.saveBo.id;
    this.EventList?.forEach((element) => {
      element.eventId = this.saveBo.id;
      element.eventAlertId = element.eventAlertId;
      element.eventAlterName = element.eventAlterName;
      element.eventAlertValue = element.eventAlertValue;
    });
    if (this.global.isSDPtoEvent) {
      saveEventsBo.serviceDeliveryPlanId = this.EBO.serviceDeliveryPlanId;
    }
  saveEventsBo.languageListIds = this.selectedLanguages.length >0 ? this.selectedLanguages : []
    saveEventsBo.eventAlterList = this.EventList.filter(f=> f.isCheck == true)
    this.EventService.SaveEvents(saveEventsBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (saveEventsBo.id == null || saveEventsBo.id == undefined || saveEventsBo.id == "") {
        this.toastrService.success("Events saved Successfully!");
      }
      else {
        this.toastrService.success("Events Updated Successfully!");
      }
      if(!this.inputfromCalendar){
      this.getEventsListFilter();
      }
      document.getElementById("openEventsModal").click();
      this.clearEvents();     
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
      })
  }

  GetLovDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "EVENTALERT");
    this.EventService.getLovValues(params).subscribe((data: any) => {
      data?.forEach((element) => {
        element.eventAlertId = element.id;
        element.isCheck = false;
        element.eventAlterName = element.lovName;
        element.eventAlertValue = element.lovValue;
      });
      this.EventList = data;
      this.EvaluesList = JSON.parse(JSON.stringify(data));
    });
  }
  GetStatusLovDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "EVENTSTATUS");
    this.EventService.getLovValues(params).subscribe((data: any) => {
      this.StatusList = data;
    });
  }
  ServiceList: any = [];
  // Service Type
  async GetServiceType(): Promise<void> {
    return new Promise((resolve, reject) => {
      // if (this.saveBo.clientId != null && this.saveBo.clientId != undefined) {
      let params = new URLSearchParams();
      // params.append("ClientId", this.saveBo.clientId)
      this.CSService.getServiceValues(params).subscribe((data: any) => {
        this.ServiceList = data;

        resolve(data);
        // if (this.ServiceList.length == 0) {
        //   this.saveBo.typeofServiceId = null;
        // }
        // else{
        //   this.saveBo.typeofServiceId= this.saveBo.typeofServiceId;
        // }
      });
      // } else {
      resolve();
      this.ServiceList = [];
      // this.saveBo.typeofServiceId = null;
      // }
    });
  }

  GetContactType() {
    let params = new URLSearchParams();
    params.append("ListCode", "SESSIONCONTACTTYPE");
    this.EventService.getLovValues(params).subscribe((data: any) => {
      this.ContactList = data;
    });
  }

  missingDocuments: any = [];
  Getclientmodelandlanguage(edit: boolean) {
    let url = "api/Event/GetEventClientData?";

    let params = new URLSearchParams();
    params.append("clientId", this.saveBo.clientId);

   if( this.saveBo.clientId ==null ||  this.saveBo.clientId == undefined ||  this.saveBo.clientId=="")
    {
      this.saveBo.cfssModel = "";
      this.selectedLanguages = [];
      this.saveBo.languageListIds = [];
      this.missingDocuments = [];
    } else {
      this.EventService.getDropdown(url + params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            console.log(data, "data===================");
            this.clientConfirmation = data[0].clientConfirmation;
            let val: any = [];
            if (data.length > 0) {
              if (
                this.saveBo.id == "00000000-0000-0000-0000-000000000000" ||
                edit
              ) {
                this.saveBo.cfssModel = data[0].cfssModel;
                this.saveBo.languageListIds = data[0].languageLIds;
                this.selectedLanguages = [];
                data[0].languageLIds.forEach((element) => {
                  let valtemp = element.toString();
                  val.push(valtemp);
                });
                this.selectedLanguages = val;
              } else if (
                this.saveBo.id != "00000000-0000-0000-0000-000000000000" &&
                this.selectedLanguages.length == 0
              ) {
                this.saveBo.languageListIds = data[0].languageLIds;
                this.selectedLanguages = [];
                data[0].languageLIds.forEach((element) => {
                  let valtemp = element.toString();
                  val.push(valtemp);
                });
                this.selectedLanguages = val;
              } else if (
                this.saveBo.id != "00000000-0000-0000-0000-000000000000" &&
                (this.saveBo.cfssModel == "" ||
                  this.saveBo.cfssModel == null ||
                  this.saveBo.cfssModel == undefined)
              ) {
                this.saveBo.cfssModel = data[0].cfssModel;
              }

              console.log(this.selectedLanguages, "this.selectedLanguages");

              //  this.selectedLanguages= data[0].languageLIds

              this.missingDocuments = data[0].requiredDocuments;
            }
          },
          (err: any) => {
            if (err) {
              this.toastrService.error(err, "Error"), 8000;
            }
          }
        );
    }
  }

  getLanguageList() {
    let url = "api/Language/GetLanguageList";
    this.ClientService.GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.languageList = data;
          this.languageList.forEach((element) => {
            element.id = element.id.toString();
          });
        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
  languageselect() {
    console.log(this.selectedLanguages, "selectlanguages=========");
  }

    //......................................routerToEmployee.....................................
    routerToClient(list) {
      const urlTree = this.router.createUrlTree(["/Client"]);
      const url = this.router.serializeUrl(urlTree);
      this.global.isClientNewTab = true;
      // this.global.searchClientText = list.clientName;
      this.global.EventClientid = list.clientId;
      this.global.searchClientStatus = 'Active';
      let ClientShortFunctionality = {
        isClientNewTab: this.global.isClientNewTab,
        ClientName: list,
        ClientId: list.clientId,
      };
      localStorage.setItem(
        "cfss_ClientNewTabFunctionality",
        JSON.stringify(ClientShortFunctionality)
      );
      window.open("#" + url, "_blank");
    }

  onCellSelected(event: CellSelectEventArgs): void {
    console.log(event, "event==================");

    // Check if the selected column is the "Client Name" column
    // if (event?.currentCell?.column?.field === 'clientName') {
    //   const clientName = event.data['clientName']; // Retrieve the client name from row data
    //   const url = `https://example.com/client/${clientName}`;
    //   window.open(url, '_blank'); // Open the URL in a new tab
    // }
  }

  onRowSelected(args: any): void {
    console.log("Selected row data:", args.data);

    // If specific column data is needed
    const clientName = args.data["clientName"];
    if (clientName) {
      this.routerToClient(clientName);
    }
  }

  clickCLientName(data) {
    console.log(data, "clickCLientName");

    this.routerToClient(data);
  }
  addclientid() {
    if (this.global.isSDPtoEvent) {
      this.saveBo.clientId = this.EBO.clientId;
    }
    this.isEditClient = false;
    this.saveBo.getConfirmation = true;
    this.getConfirmation = true;
  }
   
validateDateswith24Hours() {
  if (this.StartDate && this.EndDate) {
    const start = new Date(this.StartDate);
    const end = new Date(this.EndDate);
    const diffInMs = end.getTime() - start.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    if (diffInHours > 24) {
      this.isDateCheck = true;
    } else {
      this.isDateCheck = false;
    }
  } else {
    this.isDateCheck = false;
  }
}

  OutBoundCall() {
    const currentDateTime = new Date();
    const EventStartdate = new Date(this.StartDate);
    const EventEnddate = new Date(this.EndDate);

    // Extract business hours (only hr & min)
    const businessStartTime = new Date(this.global.businessStartTime);
    const businessEndTime = new Date(this.global.businessEndTime);
    const startHour = businessStartTime.getHours();
    const startMin = businessStartTime.getMinutes();
    const endHour = businessEndTime.getHours();
    const endMin = businessEndTime.getMinutes();

    // Build today/tomorrow markers
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Build today's business window
    const businessStartToday = new Date(today);
    businessStartToday.setHours(startHour, startMin, 0, 0);

    const businessEndToday = new Date(today);
    if (endHour < startHour)
      businessEndToday.setDate(businessEndToday.getDate() + 1);
    businessEndToday.setHours(endHour, endMin, 0, 0);

    // Build next‐day business start
    const nextDayBusinessStart = new Date(tomorrow);
    nextDayBusinessStart.setHours(startHour, startMin, 0, 0);

    const fifteenMinutes = 15 * 60 * 1000;
    const eventTime = EventStartdate.getTime();
    const currentTime = currentDateTime.getTime();

    const isToday = EventStartdate.toDateString() === today.toDateString();
    const isTomorrow = EventStartdate.toDateString() === tomorrow.toDateString();
  console.log(today , tomorrow , isToday , isTomorrow , businessStartToday , businessEndToday ,nextDayBusinessStart )
   console.log(  this.getConfirmation , this.global.isValidCcxAccessKey ,this.clientConfirmation  , currentTime , eventTime , EventStartdate , currentDateTime )

    if (
      this.getConfirmation &&
      this.global.isValidCcxAccessKey &&
      this.clientConfirmation &&
      (isToday || isTomorrow) 
    ) {
      if( isToday && eventTime < currentTime)
      {
          this.msg = "the event time is passed ";
           document.getElementById("openNoCallModel")?.click();
      }
      else if( isToday && eventTime <= currentTime +fifteenMinutes)
        {
           this.msg = "short notice";
           document.getElementById("openNoCallModel")?.click();
        }
      // 1st: Today & within business hours (±15min)
      else if (isToday && eventTime < businessStartToday.getTime()+fifteenMinutes) {
        this.msg = "it is outside of business hours"
        document.getElementById("openNoCallModel")?.click();
      }
     else if (
        isToday &&
        currentTime < businessEndToday.getTime() - fifteenMinutes &&
        eventTime > businessStartToday.getTime() + fifteenMinutes
      ) {
        document.getElementById("opencallModel")?.click();

        // 2nd: Today but after business end, before next day's start+15
      } else if (
        isToday || isTomorrow &&
        currentTime > businessEndToday.getTime() - fifteenMinutes &&
        eventTime < nextDayBusinessStart.getTime() + fifteenMinutes
      ) {
        this.msg = "it is outside of business hours"
        document.getElementById("openNoCallModel")?.click();

        // 3rd: Event is beyond next day's start +15 → allow call
      } 
       else if (eventTime > nextDayBusinessStart.getTime() + fifteenMinutes) {
        this.saveBo.getConfirmation = true;
        this.SaveEvents();
      }
       else {
        this.saveBo.getConfirmation = true;
         this.SaveEvents();
       }
    } 
    else {
      if(this.getConfirmation == false)
        this.saveBo.getConfirmation = false;
      else
      this.saveBo.getConfirmation = true;
      this.SaveEvents();
        }
  }

  SaveCallEvent() {
    this.saveBo.getConfirmation = true;
    this.SaveEvents();
    document.getElementById("opencallModel")?.click();
  }
  StartDateChange(){
    this.getConfirmation = true;
  }
}  